/**
 * @file English language pack
 * @description English translations
 */

export default {
  common: {
    welcome: 'welcome',
  },
}
